import {
  ChecklistItemType,
  RefundRequestComponentStatus,
  RefundRequestStatus,
  RefundRequestStatusFilter,
  refundRequestStatusFilterValues,
} from "../common/types";

export function stringToChecklistItemType(str: string): ChecklistItemType {
  return stringToEnum<ChecklistItemType>("ChecklistItemType", ChecklistItemType, str);
}

export function stringToRefundRequestComponentStatus(str: string): RefundRequestComponentStatus {
  return stringToEnum<RefundRequestComponentStatus>("RefundRequestComponentStatus", RefundRequestComponentStatus, str);
}

export function stringToRefundRequestStatus(str: string): RefundRequestStatus {
  return stringToEnum<RefundRequestStatus>("RefundRequestStatus", RefundRequestStatus, str);
}

export function stringToRefundRequestStatusFilter(str: string): RefundRequestStatusFilter {
  return stringToEnum<RefundRequestStatusFilter>("RefundRequestStatusFilter", refundRequestStatusFilterValues, str);
}

function stringToEnum<T extends string>(enumName: string, runtimeEnum: any, value: string): T {
  if (stringIsEnum<T>(runtimeEnum, value)) {
    return value;
  }
  throw new Error(`Invalid ${enumName} ${value}`);
}

function stringIsEnum<T extends string>(runtimeEnum: any, value: string): value is T {
  return (Object.values(runtimeEnum) as any[]).includes(value);
}
